// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__-b4yd","smallBox":"style_smallBox__MAFa1","mediumBox":"style_mediumBox__U7iEV","chartBox":"style_chartBox__mCxwR"};